import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";
import codes from 'country-calling-code';
import Select from 'react-select';
import countryName from "./countryName.json"
const UserKyc = () => {

	const [searchParams] = useSearchParams();
	const userId = searchParams.get('user_id');

	const [formData, setFormData] = useState({
		fullName: "",
		phoneNumber: "",
		dateOfBirth: "",
		countryCode: "+91",
		country: "India",
		state: "",
		city: "",
		userId: userId,
	});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			LoaderHelper.loaderStatus(true);
			const result = await AuthService.submitKyc(formData);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				navigate("/");
			} else {
				alertErrorMessage(result || 'Submission failed');
			}
		} catch (error) {
			alertErrorMessage(error?.message || 'An error occurred during submission');
		} finally {
			LoaderHelper.loaderStatus(false);
		}
	};

	const handleCountryCodeChange = (selectedOption) => {
		if (selectedOption === null) {
			return;
		}
		const { value } = selectedOption;
		setFormData({ ...formData, countryCode: value });
	};

	const countryOptions = codes.map((country, index) => ({
		value: "+" + country.countryCodes[0],
		label: `${country.country} (+${country.countryCodes[0]})`,
	}));


	const handleCountryChange = (selectedOption) => {
		if (selectedOption === null) {
			return;
		}
		const { value } = selectedOption;
		setFormData({ ...formData, country: value });
	};

	const countryData = countryName.map((country, index) => ({
		value: `${country.name}`,
		label: `${country.name}`,
	}));

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			backgroundColor: state.isSelected ? 'black' : 'white',
			color: state.isSelected ? 'white' : 'black',
			fontSize: '14px',
			borderRadius: '4px',

		}),
	};

	return (
		<div className="wrapper saprate_page">
			<div className="page-body">
				<div className="page-wrap">
					<div className="page_wrapper copier_wrapper">
						<div className="page_wrapper">
							<div className="container">
								<div className="row justify-content-center mt-md-5">
									<div className="col-lg-10">
										<div className="terms_content">
											<div className="card">
												<div className="card-body">
													<h3>Provide Your Details</h3>
													<p>
														Share your personal details to get full access to our services.
														We'll keep your information safe.
													</p>
													<hr />
													<form onSubmit={handleSubmit}>
														<div className="row justify-content-start py-3">
															<div className="col-lg-7 col-md-8">
																<div className="form-group mb-3">
																	<label className="form-label">Full Name</label>
																	<input
																		className="form-control"
																		type="text"
																		name="fullName"
																		value={formData.fullName}
																		onChange={handleInputChange}
																		required
																	/>
																</div>
																<div className="row">

																	<div className="col-md-4">
																		<label className="form-label">Country Code</label>

																		<Select
																			className="mb-3"
																			name="countryCode"
																			onChange={handleCountryCodeChange}
																			options={countryOptions}
																			value={countryOptions.find(option => option.value === formData.countryCode)}
																			styles={customStyles}
																		/>
																	</div>

																	<div className="col-md-8">
																		<label className="form-label">Phone Number</label>
																		<input
																			className="form-control"
																			type="text"
																			name="phoneNumber"
																			value={formData.phoneNumber}
																			onChange={handleInputChange}
																			required
																			maxLength={10}
																			minLength={10}
																		/>
																	</div>
																</div>

																<div className="form-group mb-4">
																	<label className="form-label">Date of Birth</label>
																	<input
																		className="form-control"
																		type="date"
																		name="dateOfBirth"
																		value={formData.dateOfBirth}
																		onChange={handleInputChange}
																		required
																	/>
																</div>

																<div className="form-group mb-4">
																	<label className="form-label">Country</label>

																	<Select
																		className="mb-3"
																		name="country"
																		onChange={handleCountryChange}
																		options={countryData}
																		value={countryData.find(option => option.value === formData.country)}
																		styles={customStyles}
																	/>

																</div>

																<div className="form-group mb-4">
																	<label className="form-label">State</label>
																	<input
																		className="form-control"
																		type="text"
																		name="state"
																		value={formData.state}
																		onChange={handleInputChange}
																		required
																	/>
																</div>

																<div className="form-group mb-4">
																	<label className="form-label">City</label>
																	<input
																		className="form-control"
																		type="text"
																		name="city"
																		value={formData.city}
																		onChange={handleInputChange}
																		required
																	/>
																</div>
																<div className="form-group">
																	<button
																		className="btn btn-primary w-100 btn-block"
																		type="submit"
																	>
																		Submit
																	</button>
																</div>
															</div>
														</div>
													</form>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UserKyc;
